import { AUTH0_CALLBACK_PATH, SIGNED_OUT_PATH } from '../../utils/auth0Config';

/**
 * Whether this page load began on a deep link rather than the home page.
 *
 * The onboarding tour always finishes on the home page, so a first-run redirect from a deep link
 * would lose the page the user asked for. A visit that begins on one skips the tour, which then
 * shows on the next visit that begins at the home page.
 *
 * Settled once per page load, on the first read: callers read it only once the user is signed in,
 * by which point a sign-in has already put its return page back. Moving around afterwards — to
 * the home page included — does not bring the tour up mid-visit.
 */
let landingPath: string | undefined;

/**
 * Auth0's own landing pages count as home: no route matches them, so a visit that begins there
 * ends on the home page anyway, and nothing the user asked for is lost to the tour.
 */
const HOME_PATHS: ReadonlySet<string> = new Set(['/', AUTH0_CALLBACK_PATH, SIGNED_OUT_PATH]);

export function landedOnDeepLink(): boolean {
  landingPath ??= window.location.pathname;
  return !HOME_PATHS.has(landingPath);
}

/** @internal Exposed for tests only: forget the landing page so the next read takes it afresh. */
export function resetLandingPageForTests(): void {
  landingPath = undefined;
}
